export default (prefix, modifiers) =>
  modifiers.map(modifier => prefix + modifier).join(' ');
